<template>
  <div class="jifen-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="会员手机号/姓名">
          <el-input v-model="filterForm.keyword" placeholder="请输入手机号或姓名" clearable style="width: 200px;" />
        </el-form-item>
        <el-form-item label="最低余额">
          <el-input-number v-model="filterForm.min_balance" :min="0" :step="1" controls-position="right" style="width: 140px;" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="accountList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="会员" min-width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.mem_name || '—' }}</div>
            <div style="color: #999; font-size: 12px;">{{ scope.row.mem_user }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="crm_id" label="会员ID" width="100" align="center" />
        <el-table-column prop="invite_code" label="邀请码" width="110" align="center" />
        <el-table-column label="当前余额" width="120" align="center">
          <template slot-scope="scope">
            <span class="balance">{{ scope.row.balance }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计获得" width="110" align="center">
          <template slot-scope="scope">
            <span style="color: #67c23a;">{{ scope.row.total_in }}</span>
          </template>
        </el-table-column>
        <el-table-column label="累计消耗" width="110" align="center">
          <template slot-scope="scope">
            <span style="color: #f56c6c;">{{ scope.row.total_out }}</span>
          </template>
        </el-table-column>
        <el-table-column label="余额范围" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.scope === 'platform' ? 'warning' : 'info'">
              {{ scope.row.scope === 'platform' ? '平台通用' : '店铺' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="160" />
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openAdjustDialog(scope.row, 'add')">增加积分</el-button>
            <el-button type="text" size="small" style="color: #f56c6c;" @click="openAdjustDialog(scope.row, 'sub')">扣减积分</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 人工调整弹窗 -->
    <el-dialog
      :title="adjustMode === 'add' ? '人工增加积分' : '人工扣减积分'"
      :visible.sync="adjustDialogVisible"
      width="480px"
      :close-on-click-modal="false"
      @close="closeAdjustDialog"
    >
      <el-form ref="adjustForm" :model="adjustForm" :rules="adjustRules" label-width="100px">
        <el-form-item label="会员">
          <span>{{ adjustForm.mem_name || '—' }} ({{ adjustForm.mem_user }})</span>
        </el-form-item>
        <el-form-item label="当前余额">
          <span class="balance">{{ adjustForm.balance }}</span> 积分
        </el-form-item>
        <el-form-item :label="adjustMode === 'add' ? '增加积分' : '扣减积分'" prop="points">
          <el-input-number v-model="adjustForm.points" :min="1" :step="1" style="width: 200px;" />
          <span style="margin-left: 8px;">积分</span>
        </el-form-item>
        <el-form-item label="调整原因" prop="remark">
          <el-input v-model="adjustForm.remark" type="textarea" :rows="3" placeholder="请输入调整原因（必填）" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="adjustDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdjust" :loading="adjustSubmitting">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { accountLists, manualAdjust } from '@/api/jifen'

export default {
  name: 'JifenAccounts',
  data () {
    return {
      loading: false,
      accountList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        keyword: '',
        min_balance: null
      },
      // 人工调整弹窗
      adjustDialogVisible: false,
      adjustMode: 'add',
      adjustSubmitting: false,
      adjustForm: {
        crm_id: null,
        mem_name: '',
        mem_user: '',
        balance: 0,
        points: 0,
        remark: ''
      },
      adjustRules: {
        points: [{ required: true, message: '请输入积分数量', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入调整原因', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.keyword) params.keyword = this.filterForm.keyword
        if (this.filterForm.min_balance !== null && this.filterForm.min_balance !== undefined && this.filterForm.min_balance !== '') {
          params.min_balance = this.filterForm.min_balance
        }
        const res = await accountLists(params)
        if (res && res.code === '0') {
          this.accountList = res.data || []
          this.total = res.total || 0
        } else {
          this.accountList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取积分账户失败')
        }
      } catch (error) {
        console.error('获取积分账户失败', error)
        this.accountList = []
        this.total = 0
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { keyword: '', min_balance: null }
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    },

    openAdjustDialog (row, mode) {
      this.adjustMode = mode
      this.adjustForm = {
        crm_id: row.crm_id,
        mem_name: row.mem_name || '—',
        mem_user: row.mem_user,
        balance: row.balance,
        points: 0,
        remark: ''
      }
      this.adjustDialogVisible = true
    },

    closeAdjustDialog () {
      this.$refs.adjustForm && this.$refs.adjustForm.resetFields()
    },

    async submitAdjust () {
      try {
        await this.$refs.adjustForm.validate()
      } catch (e) {
        return
      }
      this.adjustSubmitting = true
      try {
        const points = this.adjustMode === 'add' ? this.adjustForm.points : -this.adjustForm.points
        const res = await manualAdjust({
          crm_id: this.adjustForm.crm_id,
          points,
          remark: this.adjustForm.remark
        })
        if (res && res.code === '0') {
          this.$message.success(res.message || '操作成功')
          this.adjustDialogVisible = false
          this.fetchList()
        } else {
          this.$message.error(res && res.msg ? res.msg : '操作失败')
        }
      } catch (error) {
        console.error('人工调整失败', error)
        if (error && error.message) {
          this.$message.error(error.message)
        } else {
          this.$message.error('网络错误，请稍后重试')
        }
      } finally {
        this.adjustSubmitting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jifen-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  .balance {
    color: #e6a23c;
    font-weight: bold;
  }
}
</style>
